<ng-container>
  <div class="tooltip">{{ tooltipText }}</div>
</ng-container>`
